export const myProfileDataCrypto = [
  {
    id: "1",
    question: "Who is Yolo247?",
    answer: "Yolo247 is where casino excitement meets sports action---all in one spot. With 700+ casino games and sports betting options, it's about having fun. With the crypto payment method, deposits and withdrawals have become quick and easy. With exciting bonuses and 24/7 support, the platform becomes a place to enjoy your online gaming experience.",
    lists: []
  },
  {
    id: "2",
    question: "Why Yolo247?",
    answer: "Yolo247 is not just another casino that is trying to offer similar products from other players in the market. After intensive market research, the highly skilled team has built this product from scratch to be the best iGaming entertainment service provider. We offer a wide range of options to bet on: from multiple sports events, virtual sports, special markets, to live casino and live card games. Our odds and policies are designed to be the best. We've also simplified the promotions to ensure you are entertained 24/7.",
    lists: [
      { id: "1", content: "100% welcome bonus" },
      { id: "2", content: "Up to 3% Redeposit Bonus" },
      { id: "3", content: "Faster withdrawals" },
      { id: "4", content: "Exciting loyalty programs" },
      { id: "5", content: "24/7 client support to ensure 24/7 entertainment" }
    ]
  },
  {
    id: "3",
    question: "How to log in to Yolo247?",
    answer: "",
    lists: [
      { id: "1", content: "Click on login" },
      { id: "2", content: "Fill in your details" },
      { id: "3", content: "Verify your email address" },
      { id: "4", content: "Accept T&C's" },
      { id: "5", content: "Click on the sign-up option & you are ready to roll!!" }
    ]
  },
  {
    id: "4",
    question: "How can I update my personal information?",
    answer: "",
    lists: [
      { id: "1", content: "Click on the drop-down arrow next to your username" },
      { id: "2", content: "Choose Profile" },
      { id: "3", content: "Click on 'Account Info'" },
      { id: "4", content: "Accept T&C's" },
      { id: "5", content: "Then click on the edit option." }
    ]
  },
  {
    id: "5",
    question: "How to reset the password?",
    answer: "",
    lists: [
      { id: "1", content: "Click on the dropdown arrow next to your username" },
      { id: "2", content: "Choose Profile" },
      { id: "3", content: "Select the password option on the left menu" },
      { id: "4", content: "Verify account through email verification" },
      { id: "5", content: "Change your password" }
    ]
  },
  {
    id: "6",
    question: "Where can I see my betting history?",
    answer: "",
    lists: [
      { id: "1", content: "Click on the dropdown arrow next to your username" },
      { id: "2", content: "Select the option 'Bet details'." }
    ]
  },
  {
    id: "7",
    question: "I did not receive OTP during verification. What should I do now?",
    answer: "Please verify the entered Email once again. If the problem persists, kindly contact customer care for assistance.",
    lists: []
  },
  {
    id: "8",
    question: "Why am I not able to see my balance?",
    answer: "Your balance is safe! If your balance isn't visible after returning to the homepage and refreshing the page, kindly contact customer care for assistance.",
    lists: []
  },
  {
    id: "9",
    question: "What if I lose internet connectivity while playing the games?",
    answer: "All game rounds are logged, and the successful bets are still valid. Please refer to our disconnection policy.",
    lists: []
  },
  {
    id: "10",
    question: "Suddenly, the video I was streaming got stuck. What should I do?",
    answer: "No problem! This usually happens due to slow internet connectivity or when you run multiple programs. Try clearing the cache and reducing the screen resolution.",
    lists: []
  },
  {
    id: "11",
    question: "What is the best gambling site for crypto?",
    answer: "Thinking about gambling with crypto? Yolo247 is worth checking out. It supports USDT (Tether), so you can deposit and withdraw without all the usual bank delays, no fuss, no waiting. Just a clean, simple way to get into the game.<br/>Whether you're betting on cricket or going to a live casino table, using crypto on Yolo247 is pretty straightforward. The best part? You don't have to be a crypto pro to get started. It's simple enough for anyone to understand, even if it's your first time using USDT on a gaming site.",
    lists: []
  },
  {
    id: "12",
    question: "How do you bet with crypto?",
    answer: "Betting with crypto is pretty straightforward and fast.",
    lists: [
      { id: "1", content: "Create an account on Yolo247 by providing the required information." },
      { id: "2", content: "After signing up, you need to deposit into your gaming account. Deposit using USDT cryptocurrency usually takes just a few minutes." },
      { id: "3", content: "Now you can choose your preferred casino game or sports betting market to place your wager." },
      { id: "4", content: "You can either keep playing or withdraw your crypto back to your wallet. The process is usually quicker and more secure than traditional payment methods, with fewer fees and no need to share personal banking info." }
    ]
  }
];

export const bonusDataCrypto = [
  {
    id: "1",
    question: "How to get a bonus?",
    answer: "Yes, who wouldn't like a little extra? We offer <a href='/promotions'>various bonuses</a>, most of which are automatically activated once your deposits are successful.",
    lists: []
  },
  {
    id: "2",
    question: "How much is the welcome bonus?",
    answer: "At Yolo247, we always want to welcome you with the best and simplest bonus offers. After registration, you will receive a 100% <a href='/promotions/welcome-bonus'>Welcome Bonus</a> when you make your first deposit & complete 20X RO. <a href='/promotions/welcome-bonus'>CLICK HERE</a> to check the latest promotion offer.",
    lists: []
  },
  {
    id: "3",
    question: "How much is the refill bonus?",
    answer: "A little extra never hurts; you deserve it for your continued trust in us. When you meet the wagering amount, you can win up to a 3% <a href='/promotions/refill-bonus'>refill bonus</a>. So, <a href='/promotions/refill-bonus'>CLICK HERE</a> to check the latest refill bonus.",
    lists: []
  },
  {
    id: "4",
    question: "How much is the cashback bonus?",
    answer: "We understand that every week isn't as lucky as your luckiest week. In such cases, we've got you covered with weekly losses. <a href='/promotions/cashback-bonus'>CLICK HERE</a> to learn more about the latest <a href='/promotions/cashback-bonus'>cashback offer</a>. Why wait?",
    lists: []
  },
  {
    id: "5",
    question: "Why am I not able to withdraw my bonus amount?",
    answer: "We have curated our bonus structure to be simple yet effective. Bonus amount(s) cannot be withdrawn, but any winnings from the bonus amount can be withdrawn immediately.",
    lists: []
  },
  {
    id: "6",
    question: "What are the various bonus offers available at Yolo247?",
    answer: "Click on <a href='/promotions'>Promotions<a/> on the home screen page to view the various available bonus programs.",
    lists: []
  },
  {
    id: "7",
    question: "What is the validity of the bonus program?",
    answer: "It depends on the chosen bonus program and will expire if not consumed during the allotted period.",
    lists: [
      { id: "1", content: "Welcome bonus: 7 days; Refill bonus: 24 hours & Cashback bonus: 48 hours" }
    ]
  },
  {
    id: "8",
    question: "How is RO calculated at Yolo247?",
    answer: "Rollover is a simple concept, yet at Yolo247, we have simplified it further by saying 'A valid RO is when your win/loss is at least 10% of your stake amount.",
    lists: []
  }
];

export const DepositDataCrypto = [
  {
    id: "1",
    question: "What is the minimum & maximum amount for a Deposit?",
    answer: "The minimum deposit amount can range from $10+ depending upon the payment channel used.",
    lists: []
  },
  {
    id: "2",
    question: "How can I deposit?",
    answer: "Click on the Deposit option on the home page and click on Payment Options to make your deposit.",
    lists: []
  },
  {
    id: "3",
    question: "Can I transfer my balance from one Yolo247 account to another Yolo247 account?",
    answer: "You cannot transfer your balance from one account to another.",
    lists: []
  },
  {
    id: "4",
    question: "My amount is stuck. What to do?",
    answer: "",
    lists: [
      { id: "1", content: "Not to worry. Just click on the dropdown arrow next to your username" },
      { id: "2", content: "Click on the option Finances" },
      { id: "3", content: "Select the option wallet transfer, and select transfer All to the main wallet & you are done!" },
      { id: "4", content: "If you need further assistance, contact Customer Service." }
    ]
  },
  {
    id: "5",
    question: "What cryptocurrencies are used for gambling on Yolo247?",
    answer: "Currently, Yolo247 lets you use Tether (USDT) for deposits and withdrawals. We plan to add more cryptocurrencies soon, giving you even more easy and secure options.",
    lists: []
  },
  {
    id: "6",
    question: "How long will my deposit take to reflect in my account?",
    answer: "Your deposit will be credited to your account once it's confirmed on the blockchain and processed by our system.",
    lists: []
  },
  {
    id: "7",
    question: "Where can I see my transaction history?",
    answer: "",
    lists: [
      { id: "1", content: "Click on the dropdown arrow next to your username" },
      { id: "2", content: "Click on the option Finances" },
      { id: "3", content: "Select the option history" }
    ]
  },
  {
    id: "8",
    question: "What is the minimum & maximum amount for withdrawal?",
    answer: "There is no minimal withdrawal amount, and the maximum withdrawal is $5000 per day.",
    lists: []
  },
  {
    id: "9",
    question: "How can I withdraw my balance?",
    answer: "",
    lists: [
      { id: "1", content: "Just click on the dropdown arrow next to your username" },
      { id: "2", content: "Click on the option Finances" },
      { id: "3", content: "Select the option Withdrawal!" }
    ]
  },
  {
    id: "10",
    question: "Why was my withdrawal put on hold?",
    answer: "Most withdrawals are either kept on hold or cancelled for the following reasons.",
    lists: [
      { id: "1", content: "The betting requirements were not fulfilled." },
      { id: "2", content: "Additionally, your account may currently be under review by our compliance team." }
    ]
  },
  {
    id: "11",
    question: "How to add a new withdrawal account?",
    answer: "",
    lists: [
      { id: "1", content: "Just click on the dropdown arrow next to your username" },
      { id: "2", content: "Click on the option Finances" },
      { id: "3", content: "Select the option Withdrawal!" },
      { id: "4", content: "You can now add or edit your crypto wallet information" }
    ]
  },
  {
    id: "12",
    question: "Can I cancel my withdrawal?",
    answer: "Yes, you may be able to, depending on the status of the transaction! Please contact customer care for this request.",
    lists: []
  }
];

export const ProductsDataCrypto = [
  {
    id: "1",
    question: "I am trying to play a game (casino/slot/teen patti), but the page is not loading.",
    answer: "A slow internet connection might be the reason; however, kindly contact our customer care for assistance.",
    lists: []
  },
  {
    id: "2",
    question: "Where can I check the status of my bet?",
    answer: "Click on the dropdown arrow next to your username, select the option Bet Details.",
    lists: []
  },
  {
    id: "3",
    question: "What does the blue & red colour in exchange mean?",
    answer: "Blue means to Back & Red means to Lay.",
    lists: []
  },
  {
    id: "4",
    question: "What are the betting rules?",
    answer: "Kindly click on the terms & conditions available at the bottom of your homepage.",
    lists: []
  },
  {
    id: "5",
    question: "What types of casino games can I play on Yolo247?",
    answer: "When it comes to Yolo247, you've got tons of options. We've got over 700 games, so whether you're into card games, slots, crash games, or dice, there's something for everyone. The cool thing is we've partnered with some top game makers like Spribe and Evolution Gaming, so you know the games are legit and run smoothly.<br/> Whatever type of game you're into, you can jump right in and start playing without any wait.",
    lists: []
  },
  {
    id: "6",
    question: "Which sports are available for betting on Yolo247?",
    answer: "From cricket to football, tennis, hockey, and badminton, we cover all sports matches to bet on. You can place your wager on virtual matches as well. At Yolo247, you can bet on all the big upcoming sports events and place live bets as the action happens - all through their BTI Sportsbook, Premium Sportsbook, and Betting Exchange.",
    lists: []
  }
];

export const affiliateDateCrypto = [
  {
    id: "1",
    question: "I am unable to view the affiliate program. When will it start?",
    answer: "We are currently working on the best affiliate program for our clients. Stay tuned, it will be available soon!",
    lists: [
      { id: "1", content: "In the meantime, please contact our Customer Care team with your details." }
    ]
  }
];

export const securityDataCrypto = [
  {
    id: "1",
    question: "Is Yolo247 licensed and legitimate?",
    answer: "Yolo247 is a licensed gaming company under the GCB regulations and is certified to operate globally. At Yolo247, we keep your information private and do not share it with any third party.",
    lists: []
  },
  {
    id: "2",
    question: "Is Yolo247 a secure platform?",
    answer: "Yes, you can trust Yolo247 when it comes to gaming. It's built with security, from encrypted transactions to verified user accounts.<br/> <br/> What stands out about Yolo247 is how simple everything feels. You get crypto's speed and privacy without worrying about your information being at risk. The site uses trusted payment gateways and follows responsible gaming practices, so it's not just about fun; it's about playing safely, too. <br/><br/> If you're into sports betting or live casino games and want a secure crypto option that just works, Yolo247 is a solid choice.",
    lists: []
  }
];